<template>
  <div>
    <div
      :class="[
        'relative mx-auto',
        desktop ? 'w-[316px]' : 'w-full max-w-[370px]',
      ]"
    >
      <MembershipCard :name="name" interactive shadow class="relative w-full" />
    </div>

    <div :class="['space-y-[10px]', desktop ? 'mt-[30px]' : 'mt-[15px]']">
      <div :class="[INFO_CARD, 'flex', desktop ? 'h-[102px]' : 'h-[62px]']">
        <div :class="[VALUE_CARD, 'min-w-0 flex-1']">
          <span :class="[VALUE, 'truncate']">{{ memberId }}</span>
          <span :class="LABEL">Member ID</span>
        </div>
        <div v-if="desktop && hasMemberId" class="flex shrink-0 items-center">
          <QrcodeVue
            :value="qrValue"
            :size="85"
            level="M"
            render-as="svg"
            :margin="0"
          />
        </div>
      </div>

      <div class="flex gap-[10px]">
        <div :class="[INFO_CARD, VALUE_CARD, 'h-[62px] flex-1']">
          <span :class="VALUE">{{ memberSince }}</span>
          <span :class="LABEL">Member since</span>
        </div>
        <div :class="[INFO_CARD, VALUE_CARD, 'h-[62px] flex-1']">
          <span :class="VALUE">{{ expiration }}</span>
          <span :class="LABEL">Expiration</span>
        </div>
      </div>

      <button
        type="button"
        :class="[
          INFO_CARD,
          'flex h-[38px] w-full cursor-pointer items-center justify-between transition hover:border-gray-300',
        ]"
        @click="handleLearn"
      >
        <span class="text-[15px] font-medium leading-[21px] text-gray-800">
          Learn about your Dacr Membership
        </span>
        <ChevronRightIcon class="size-4 shrink-0 text-gray-800" />
      </button>
    </div>

    <div v-if="!desktop && hasMemberId" class="mt-[42px] flex justify-center">
      <QrcodeVue
        :value="qrValue"
        :size="190"
        level="M"
        render-as="svg"
        :margin="0"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import QrcodeVue from 'qrcode.vue'
import { computed } from 'vue'

import { ChevronRightIcon } from '@dacr/icons'

import MembershipCard from '@/shared/components/MembershipCard.vue'
import { useUserStore } from '@/shared/stores/user'
import { formatTimestamp } from '@/shared/utils/datetime'

defineProps<{ desktop?: boolean }>()

const PLACEHOLDER = '—'

const INFO_CARD = 'rounded-[10px] border border-[#ebedef] px-4'
const VALUE_CARD = 'flex flex-col pt-[10px]'
const VALUE = 'text-[18px] font-medium leading-[22px] text-gray-800'
const LABEL = 'mt-[2px] text-[14px] leading-[18px] text-gray-500'

const userStore = useUserStore()
const name = computed(() => userStore.user?.name ?? 'Jessica Ramsey')
const membership = computed(() => userStore.user?.membership)

const formatDate = (timestamp?: number | null) =>
  (timestamp &&
    formatTimestamp(timestamp, {
      formatString: userStore.user?.dateFormat || 'M/d/yyyy',
    })) ||
  PLACEHOLDER

const memberId = computed(() => membership.value?.id || PLACEHOLDER)
const hasMemberId = computed(() => !!membership.value?.id)
const qrValue = computed(() => membership.value?.id ?? '')
const memberSince = computed(() => formatDate(membership.value?.since))
const expiration = computed(() => formatDate(membership.value?.expiresAt))

const handleLearn = () => {
  window.open('/membership', '_blank', 'noopener')
}
</script>
